import React from "react";
import { Flex, Box } from "grid-styled";
import { Panel, PanelBody } from "../Panel";
import Link from "../Link";
import { urlRoot } from "../../utils/helpers";

const ReportCard = ({ children }) => (
  <Box w={[1 / 3]} px={2} pb={3}>
    <Panel>
      <PanelBody>{children}</PanelBody>
    </Panel>
  </Box>
);

const Reports = ({ match }) => (
  <Flex p={3} mx={-2} wrap>
    <ReportCard>
      <Link to={`${urlRoot(match.url)}/reports/daily-sales`}>Daily Sales</Link>
    </ReportCard>
    <ReportCard>
      <Link to={`${urlRoot(match.url)}/reports/monthly-sales-by-franchise`}>
        Monthly Sales By Franchise
      </Link>
    </ReportCard>
    <ReportCard>
      <Link to={`${urlRoot(match.url)}/reports/sales-by-salesperson`}>
        Sales by Salesperson
      </Link>
    </ReportCard>
  </Flex>
);

export default Reports;



// WEBPACK FOOTER //
// ./src/components/franchise/Reports.js